import { Link } from 'react-router-dom';

const PLANS = [
  {
    code: 'free',
    name: 'Individual Free Membership',
    price: 'Free',
    who: 'Anyone with an email address',
    includes: [
      'Selected courses',
      'Limited teacher resources',
      'Selected student resources',
      'Public communities',
      'Demonstration virtual laboratories',
    ],
  },
  {
    code: 'professional',
    name: 'Professional Membership',
    price: 'KES 2,500 / year',
    who: 'Teachers · Teacher trainers · School leaders',
    featured: true,
    includes: [
      'Unlimited CPD courses',
      'Digital certificates',
      'The full Teacher Resource Centre',
      'The Student Learning Centre',
      'Virtual laboratories',
      'Premium communities and assessments',
      'Downloads and AI teaching tools',
    ],
  },
  {
    code: 'school',
    name: 'School Membership',
    price: 'KES 25,000 / year',
    who: 'A whole school',
    includes: [
      'Unlimited teacher accounts',
      'Principal dashboard',
      'Teacher progress monitoring',
      'School analytics and institution reports',
      'Virtual laboratories',
      'School resource repository',
      'Professional development tracking',
    ],
  },
  {
    code: 'institutional',
    name: 'Institutional Membership',
    price: 'Quoted',
    who: 'Ministries · Universities · TTCs · NGOs',
    includes: [
      'Organisation dashboard',
      'National and regional analytics',
      'Training management',
      'Resource management',
      'Certification tracking',
      'Learning analytics and custom reports',
    ],
  },
];

export function MembershipPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-14">
      <h1 className="text-3xl font-bold text-ink-900">Membership &amp; subscription</h1>
      <p className="mt-3 max-w-2xl text-ink-700">
        Every account is free to create and keeps the free catalogue for as long as you want it.
        Prices are indicative and set per deployment; your administrator sees the exact amount at
        checkout.
      </p>

      <div className="mt-8 grid gap-4 lg:grid-cols-4">
        {PLANS.map(plan => (
          <article
            key={plan.code}
            className={`card flex flex-col ${plan.featured ? 'border-brand-500 ring-1 ring-brand-500' : ''}`}
          >
            {plan.featured && (
              <span className="badge mb-2 self-start bg-brand-100 text-brand-800">Most popular</span>
            )}
            <h2 className="text-base font-semibold text-ink-900">{plan.name}</h2>
            <p className="mt-1 text-xl font-bold text-brand-900">{plan.price}</p>
            <p className="mt-0.5 text-xs text-ink-500">{plan.who}</p>

            <ul className="mt-3 space-y-1 text-sm text-ink-700">
              {plan.includes.map(item => (
                <li key={item} className="flex gap-2">
                  <span aria-hidden="true" className="text-emerald-600">
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <Link
              to={plan.code === 'institutional' ? '/contact' : '/login'}
              className={`${plan.featured ? 'btn-primary' : 'btn-secondary'} mt-auto pt-2`}
            >
              {plan.code === 'free'
                ? 'Create an account'
                : plan.code === 'institutional'
                  ? 'Request a quote'
                  : 'Get started'}
            </Link>
          </article>
        ))}
      </div>

      <section className="mt-12 grid gap-6 sm:grid-cols-2">
        <div>
          <h2 className="text-lg font-semibold text-ink-900">Paying from Kenya</h2>
          <p className="mt-2 text-sm text-ink-700">
            Checkout accepts M-Pesa and cards through Paystack. Your card details never reach this
            platform — payment happens on the provider's own hosted page.
          </p>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-ink-900">Seats, plainly</h2>
          <p className="mt-2 text-sm text-ink-700">
            Professional membership covers one person. School and institutional memberships cover
            every member of the organisation automatically — there is no seat list for an
            administrator to maintain before their staff can start.
          </p>
        </div>
      </section>
    </div>
  );
}
